import { useCallback, useEffect, useState } from 'react';

type Response<T> = {
  data: T;
  error: any;
  loading: boolean;
};

type Options = {
  disable?: boolean;
};

export function useFetch<T = unknown>(url: string, options?: Options): Response<T> {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { disable } = options ?? { disable: false };

  const fetchData = useCallback(async () => {
    setLoading(true);
    fetch(url)
      .then(res => res.json())
      .then(data => {
        setData(data);
      })
      .catch(err => {
        setError(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [url]);

  useEffect(() => {
    if (!disable) fetchData();
  }, [disable, fetchData]);

  return { loading, data, error };
}
